// extracted by mini-css-extract-plugin
export default {"root":"BVndKIlG","noTitle":"EkN2Hi_0","footer":"gRwqhswo"};